import { useMemo, useState } from 'react';
import Helmet from '../lib/Helmet';
import * as HL from '../lib/heatLoad';
import { CATALOGUE } from '../data/catalogue';
import { PRICES, STOCK } from '../data/pricing';
import { SERIES } from '../data/highlights';
import { STATIONS } from '../data/indiaClimate';
import { AC_SPECS } from '../data/acSpecs';
import { roomACs, roomComparison } from '../data/roomDay';
import { usedSources } from '../data/guideInverter';
import {
  TEMP_SEO, TEMP_UPDATED, TEMP_SOURCES, EVENING_ROOM, NIGHT_ROOM, HARD_ROOM, TOOL_SETS,
  makeRunRoom, sweep, tempContent, settingText,
} from '../data/guideTemp';
import { GuideHeader, GuideBody, ToolCard, Choice, Rich } from '../components/guide/GuideParts';
import TempRooms from '../components/guide/TempRooms';

// Route: /blog/ideal-ac-temperature — AC guide 5, rebuilt 20 Oct 2026 to
// GUIDES_PLAYBOOK.md section 3. Every word comes from tempContent() in
// data/guideTemp.js, which scripts/guide-pages.js reads too.

function SettingTool({ pts, tool }) {
  const [setC, setSet] = useState(26);
  return (
    <ToolCard title={tool.title}>
      <Choice label="Your setting" value={setC} onChange={setSet} options={TOOL_SETS.map((c) => ({ value: c, label: `${c}°C` }))} />
      <p className="rounded-xl bg-gray-50 p-3.5 text-[17px] leading-snug text-gray-900" aria-live="polite"><Rich text={settingText(pts, setC)} /></p>
      <p className="text-[13px] text-gray-500">A 12 × 12 ft middle-floor bedroom in Delhi, used 6 pm to 2 am, 30 days.</p>
    </ToolCard>
  );
}

export default function TempGuide() {
  const { c, evening, S } = useMemo(() => {
    const acs = roomACs({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES, specs: AC_SPECS });
    const ac = acs.three || acs.list[0];
    const run = makeRunRoom(roomComparison, HL, STATIONS, ac);
    const ev = sweep(run, EVENING_ROOM);
    const content = tempContent(ev, sweep(run, NIGHT_ROOM), sweep(run, HARD_ROOM), ac.code);
    return { c: content, evening: ev, S: usedSources(TEMP_SOURCES, content) };
  }, []);
  const low = evening.find((x) => x.setC === 18);
  const high = evening.find((x) => x.setC === 24);

  return (
    <>
      <Helmet>
        <title>{TEMP_SEO.title}</title>
        <meta name="description" content={TEMP_SEO.meta} />
        <meta property="og:title" content={TEMP_SEO.title} />
        <meta property="og:description" content={TEMP_SEO.meta} />
      </Helmet>
      <main className="bg-white pb-16 pt-16 lg:pt-20">
        <article className="mx-auto max-w-[760px] px-4 text-base leading-relaxed text-gray-900">
          <GuideHeader seo={TEMP_SEO} updated={TEMP_UPDATED} crumb={TEMP_SEO.crumb} />
          <GuideBody c={c} sources={S} current="ideal-ac-temperature" ctaSource="guide_temp"
            ctaTitle="Not sure your AC is the right size for your room?"
            watch={<TempRooms low={low} high={high} watch={c.watch} sources={S} />}
            tool={<SettingTool pts={evening} tool={c.tool} />} />
        </article>
      </main>
    </>
  );
}
